import { isLoggedIn, splitioAuthKey, flagAttributes, appName, baseUrl, geoData } from '@fs/zion-config';
import zionDebug, { debugVerbose } from '@fs/zion-debug';
import { SplitFactory, ErrorLogger, WarnLogger, InfoLogger, DebugLogger } from '@splitsoftware/splitio-browserjs';
import Cookies from 'js-cookie';
import { v4 } from 'uuid';
import sha1 from 'tiny-hashes/sha1/index.js';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function getSessionId() {
    return Cookies.get('fssessionid');
}
var sessionTypes = {
    unknown: 'UNKNOWN',
    noSession: 'NO_SESSION',
    anonymousSession: 'ANONYMOUS_SESSION',
    userSession: 'USER_SESSION',
};
function getSessionType() {
    var windowDefined = typeof window !== 'undefined';
    if (!windowDefined || typeof isLoggedIn === 'undefined')
        return sessionTypes.unknown;
    if (!getSessionId())
        return sessionTypes.noSession;
    if (isLoggedIn)
        return sessionTypes.userSession;
    return sessionTypes.anonymousSession;
}
var NoUserSessionError = /** @class */ (function (_super) {
    __extends(NoUserSessionError, _super);
    function NoUserSessionError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'NoUserSessionError';
        return _this;
    }
    return NoUserSessionError;
}(Error));
function validUserSessionOrError() {
    var sessionType = getSessionType();
    if (sessionType === sessionTypes.noSession ||
        sessionType === sessionTypes.anonymousSession ||
        (sessionType === sessionTypes.unknown && !getSessionId())) {
        throw new NoUserSessionError('No User Session Id');
    }
}

var debug$2 = debugVerbose('flags-js:utils');
var HASH_BUCKETS = 10000;
// Common fetchUser function that can be used by both browser and react implementations
function fetchUser(baseUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var url, sessionId, response, responseData, user;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    validUserSessionOrError();
                    url = '/platform/users/current';
                    if (baseUrl) {
                        url = baseUrl + url;
                    }
                    sessionId = getSessionId();
                    return [4 /*yield*/, fetch(url, {
                            headers: {
                                Authorization: "Bearer ".concat(sessionId),
                                'FS-User-Agent-Chain': "fs_flags-js",
                                Accept: 'application/json',
                            },
                        })];
                case 1:
                    response = _e.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    responseData = _e.sent();
                    if (!Array.isArray((_a = responseData === null || responseData === void 0 ? void 0 : responseData.data) === null || _a === void 0 ? void 0 : _a.users) || responseData.data.users.length === 0) {
                        throw new Error('Unexpected response format from fetchUser');
                    }
                    user = (_b = responseData.data) === null || _b === void 0 ? void 0 : _b.users[0];
                    return [2 /*return*/, {
                            id: user.id,
                            contactName: (_c = user.contactName) !== null && _c !== void 0 ? _c : null,
                            gender: (_d = user.gender) !== null && _d !== void 0 ? _d : null,
                        }];
            }
        });
    });
}
// used when we take a mockFlags object. We need to convert the config into a json string consumable by Split SDK
function toSplitIOFeatures(flags) {
    if (!flags)
        return undefined;
    return Object.entries(flags).reduce(function (acc, _a) {
        var feature = _a[0], data = _a[1];
        acc[feature] = {
            treatment: typeof data === 'string' ? data : data.treatment,
            config: data.config ? JSON.stringify(data.config) : null,
        };
        return acc;
    }, {});
}
/*
 * The `hash-index` function brings in node's crypto, which brings in a ton of stuff, bloating the bundle size by around 170kb
 * Since this isn't a security important hash, we're just going to use tiny-hashes's sha1
 * hash-index used sha1 and did the weird buffer UInt16 and UInt32 stuff, so I kept that similar
 * Modified to not need node.js Buffer since Webpack no longer polyfills that, and replaced with DataView which is similar
 */
function hexToBytes(hex) {
    var data = new DataView(new ArrayBuffer(hex.length / 2));
    for (var c = 0; c < hex.length; c += 2)
        data.setUint8(c / 2, parseInt(hex.substring(c, c + 2), 16));
    return data;
}
function hasher(input, max) {
    var hash = sha1(String(input));
    var data = hexToBytes(hash);
    var hashInt = data.getUint16(0) * 0xffffffff + data.getUint32(2);
    debug$2('hasher', input, hash, hashInt);
    return hashInt % max;
}
// Common function to create anonymous key
function createAnonymousKey(anonIdCookie) {
    return "A_".concat(hasher(anonIdCookie, HASH_BUCKETS));
}
// Common function to get standard attributes
function getStandardAttributesCommon(options) {
    return __awaiter(this, void 0, void 0, function () {
        var appName, geoData, _a, locale, baseUrl, anonId, flagAttributes, attrs, _b, cisId, contactName, gender, err_1, err_2;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    debug$2('getStandardAttributesCommon called with:', options);
                    appName = options.appName, geoData = options.geoData, _a = options.locale, locale = _a === void 0 ? 'en' : _a, baseUrl = options.baseUrl, anonId = options.anonId, flagAttributes = options.flagAttributes;
                    attrs = {
                        appName: appName,
                        locale: locale,
                        country: (geoData === null || geoData === void 0 ? void 0 : geoData.country) || undefined,
                    };
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 7, , 8]);
                    debug$2('getStandardAttributesCommon: trying to create anonId', anonId);
                    // Anonymous key, re-use existing if possible
                    if (flagAttributes === null || flagAttributes === void 0 ? void 0 : flagAttributes.anonId) {
                        attrs.anonId = flagAttributes.anonId;
                    }
                    else if (!(anonId === null || anonId === void 0 ? void 0 : anonId.startsWith('A_'))) {
                        attrs.anonId = createAnonymousKey(anonId);
                    }
                    else {
                        attrs.anonId = anonId;
                    }
                    if (flagAttributes) {
                        debug$2("options.anonId=".concat(anonId, " flagAttributes.anonId=").concat(flagAttributes.anonId, " attrs.anonId=").concat(attrs.anonId));
                    }
                    if (!((flagAttributes === null || flagAttributes === void 0 ? void 0 : flagAttributes.cisId) && (flagAttributes === null || flagAttributes === void 0 ? void 0 : flagAttributes.contactName) && (flagAttributes === null || flagAttributes === void 0 ? void 0 : flagAttributes.gender))) return [3 /*break*/, 2];
                    debug$2('getStandardAttributesCommon: using flagAttributes instead of fetchUser', flagAttributes);
                    attrs = __assign(__assign(__assign({}, attrs), flagAttributes), { isSignedIn: true });
                    return [3 /*break*/, 6];
                case 2:
                    if (!getSessionId()) return [3 /*break*/, 6];
                    _c.label = 3;
                case 3:
                    _c.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, fetchUser(appName === 'hf-inj-react' ? baseUrl : undefined)];
                case 4:
                    _b = _c.sent(), cisId = _b.id, contactName = _b.contactName, gender = _b.gender;
                    attrs = __assign(__assign({}, attrs), { cisId: cisId, contactName: contactName, gender: gender, isSignedIn: !!cisId });
                    return [3 /*break*/, 6];
                case 5:
                    err_1 = _c.sent();
                    // Not logged in?
                    debug$2('getStandardAttributesCommon: fetchUser failed:', err_1);
                    return [3 /*break*/, 6];
                case 6: return [3 /*break*/, 8];
                case 7:
                    err_2 = _c.sent();
                    console.error('getStandardAttributes failed:', err_2);
                    return [3 /*break*/, 8];
                case 8:
                    // remove undefined properties
                    Object.keys(attrs).forEach(function (key) { var _a; return (_a = attrs[key]) !== null && _a !== void 0 ? _a : delete attrs[key]; });
                    return [2 /*return*/, attrs];
            }
        });
    });
}
function toFeatureFlag(_a) {
    var _b = _a === void 0 ? {} : _a, treatment = _b.treatment, config = _b.config;
    return {
        treatment: treatment,
        config: parseConfig(config),
        isOn: !/^(off|control)$/i.test(treatment),
        isControl: /^control$/i.test(treatment),
    };
}
function parseConfig(config) {
    var parsedConfig = null;
    try {
        parsedConfig = typeof config === 'string' ? JSON.parse(config) : config || null;
    }
    catch (e) {
        return null;
    }
    return parsedConfig;
}

var log = zionDebug('flags-js:featureFlagFactory');
var debug$1 = debugVerbose('flags-js:featureFlagFactory');
var factory;
var manager;
var clients = {};
var localFlagOverrides = {};
var controlFeatureFlag = {
    treatment: 'control',
    config: null,
    isOn: false,
    isControl: true,
};
function updateFlagOverrides(overrides) {
    debug$1('updateFlagOverrides:', overrides);
    localFlagOverrides = overrides;
}
function updateMockFlags(mockFlags) {
    return __awaiter(this, void 0, void 0, function () {
        var promise;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    debug$1('updateMockFlags:', mockFlags, (_a = factory === null || factory === void 0 ? void 0 : factory.settings) === null || _a === void 0 ? void 0 : _a.features);
                    if (!mockFlags) {
                        return [2 /*return*/];
                    }
                    // if new mockFlags are the same as existing flags, do nothing
                    if (JSON.stringify(toSplitIOFeatures(mockFlags)) === JSON.stringify((_b = factory === null || factory === void 0 ? void 0 : factory.settings) === null || _b === void 0 ? void 0 : _b.features)) {
                        debug$1('updateMockFlags: mockFlags are the same as existing flags, no update needed');
                        return [2 /*return*/];
                    }
                    promise = new Promise(function (resolve) {
                        var _a;
                        if (clients === null || clients === void 0 ? void 0 : clients.anonymous) {
                            // wait for the factory to update after features are updated
                            var client = clients.anonymous;
                            debug$1('updateMockFlags: waiting for SDK_UPDATE event', (_a = factory === null || factory === void 0 ? void 0 : factory.settings) === null || _a === void 0 ? void 0 : _a.features);
                            client.once(client.Event.SDK_UPDATE, function () {
                                var _a;
                                debug$1('updateMockFlags: factory features have been updated:', (_a = factory === null || factory === void 0 ? void 0 : factory.settings) === null || _a === void 0 ? void 0 : _a.features);
                                resolve();
                            });
                        }
                    });
                    if ((factory === null || factory === void 0 ? void 0 : factory.settings) && mockFlags && (clients === null || clients === void 0 ? void 0 : clients.anonymous)) {
                        debug$1('updateMockFlags: setting factory features', mockFlags);
                        factory.settings.features = toSplitIOFeatures(mockFlags);
                        // factory.settings.features = toSplitIOFeatures({
                        //   ...mockFlags,
                        //   placeholder: { treatment: Date.now().toString() },
                        // })
                    }
                    return [4 /*yield*/, promise];
                case 1:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    });
}
var getFeatureFlag = function (flagName, attributes) {
    if (attributes === void 0) { attributes = {}; }
    if (localFlagOverrides[flagName]) {
        debug$1('getFeatureFlag: using flagOverrides for flagName:', flagName, localFlagOverrides[flagName]);
        return toFeatureFlag(localFlagOverrides[flagName]);
    }
    if (!manager) {
        debug$1('getFeatureFlag: returning control because no manager found for flagName:', flagName);
        return controlFeatureFlag;
    }
    var split = manager.split(flagName);
    if (!split) {
        debug$1('getFeatureFlag: returning control because no flag found for flagName:', flagName);
        return controlFeatureFlag;
    }
    if (!split.trafficType) {
        debug$1('getFeatureFlag: no trafficType found for flagName:', flagName);
        return controlFeatureFlag;
    }
    var curClient = clients.anonymous;
    if (clients[split.trafficType]) {
        curClient = clients[split.trafficType];
    }
    debug$1('getFeatureFlag: using client for flagName:', flagName, split === null || split === void 0 ? void 0 : split.trafficType, curClient, split);
    var treatmentWithConfig = curClient.getTreatmentWithConfig(flagName, attributes);
    return toFeatureFlag(treatmentWithConfig);
};
var getFeatureFlags = function (flagNames, attributes) {
    if (attributes === void 0) { attributes = {}; }
    return flagNames.reduce(function (featureFlagAccumulator, flagName) {
        featureFlagAccumulator[flagName] = getFeatureFlag(flagName, attributes);
        return featureFlagAccumulator;
    }, {});
};
function handleAndGetAnonIdCookie() {
    // Read cookie for anonymous user
    var anonIdCookie = Cookies.get('fs_anid');
    // Create cookie, if it doesn't already exist
    if (!anonIdCookie) {
        anonIdCookie = v4();
        Cookies.set('fs_anid', anonIdCookie, { expires: 365, path: '/' });
    }
    return anonIdCookie;
}
// Helper function to determine the appropriate logger
function getLogLevel(devDebug) {
    var loggerFunction = ErrorLogger;
    if (devDebug || log.enabled) {
        loggerFunction = WarnLogger;
    }
    if (debug$1.enabled) {
        loggerFunction = InfoLogger;
    }
    if (process.env.STORYBOOK) {
        loggerFunction = ErrorLogger;
    }
    if (process.env.DEBUG_SPLIT_SDK === 'true') {
        loggerFunction = DebugLogger;
    }
    return loggerFunction();
}
function agnosticFeatureFlagFactory() {
    return __awaiter(this, arguments, void 0, function (_a) {
        var anonKey, splitioAuthKey, debugSdk, timeoutPromise, logger, SPLIT_PROXY_URL, splitConfiguration, resolvedAttributes, attributes_1, anonClient_1, userClient, result;
        var _b, _c;
        var _d = _a === void 0 ? {} : _a, _e = _d.standardAttributes, standardAttributes = _e === void 0 ? {} : _e, _f = _d.authKey, authKey = _f === void 0 ? 'localhost' : _f, _g = _d.mockFlags, mockFlags = _g === void 0 ? undefined : _g, _h = _d.flagOverrides, flagOverrides = _h === void 0 ? undefined : _h, impressionListener = _d.impressionListener;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    debug$1('agnosticFeatureFlagFactory called with:', {
                        standardAttributes: standardAttributes,
                        authKey: authKey,
                        mockFlags: mockFlags,
                        flagOverrides: flagOverrides,
                        impressionListener: impressionListener,
                    });
                    localFlagOverrides = flagOverrides || {};
                    anonKey = createAnonymousKey(handleAndGetAnonIdCookie());
                    splitioAuthKey = mockFlags ? 'localhost' : authKey;
                    debugSdk = process.env.NODE_ENV === 'development';
                    logger = getLogLevel(mockFlags ? false : debugSdk);
                    SPLIT_PROXY_URL = process.env.SPLIT_PROXY_URL;
                    if (!!factory) return [3 /*break*/, 1];
                    splitConfiguration = {
                        core: {
                            authorizationKey: splitioAuthKey,
                            key: anonKey,
                        },
                        urls: SPLIT_PROXY_URL
                            ? {
                                sdk: SPLIT_PROXY_URL,
                                events: SPLIT_PROXY_URL,
                                auth: SPLIT_PROXY_URL,
                            }
                            : undefined,
                        debug: logger,
                        impressionListener: impressionListener,
                    };
                    if (splitioAuthKey === 'localhost') {
                        // we saw weird behavior when features was undefined and then later updateMockFlags with new values wouldn't
                        // emit the SDK_UPDATE event. Setting to an empty object here seems to alleviate the issue
                        splitConfiguration.features = {};
                        splitConfiguration.scheduler = {
                            offlineRefreshRate: 0.5, // 500ms so tests are faster
                        };
                    }
                    if (mockFlags) {
                        splitConfiguration.features = toSplitIOFeatures(mockFlags);
                    }
                    log('Creating factory with splitConfiguration:', splitConfiguration);
                    factory = SplitFactory(splitConfiguration);
                    return [3 /*break*/, 3];
                case 1:
                    if (!mockFlags) return [3 /*break*/, 3];
                    return [4 /*yield*/, updateMockFlags(mockFlags)];
                case 2:
                    _j.sent();
                    _j.label = 3;
                case 3:
                    if (!(!clients.user || !clients.anonymous)) return [3 /*break*/, 7];
                    debug$1('Creating anonymous and user clients');
                    resolvedAttributes = void 0;
                    if (!(standardAttributes instanceof Promise)) return [3 /*break*/, 5];
                    return [4 /*yield*/, standardAttributes];
                case 4:
                    resolvedAttributes = _j.sent();
                    return [3 /*break*/, 6];
                case 5:
                    resolvedAttributes = standardAttributes;
                    _j.label = 6;
                case 6:
                    attributes_1 = mockFlags ? {} : resolvedAttributes;
                    // remove undefined properties
                    Object.keys(attributes_1).forEach(function (key) { var _a; return (_a = attributes_1[key]) !== null && _a !== void 0 ? _a : delete attributes_1[key]; });
                    anonClient_1 = factory.client() // uses the default anonKey from the factory core config
                    ;
                    // resolve the promise before ready if the SDK times out
                    timeoutPromise = new Promise(function (resolve) {
                        anonClient_1.once(anonClient_1.Event.SDK_READY_TIMED_OUT, function () {
                            // eslint-disable-next-line no-console -- we want to warn always if the SDK times out
                            console.warn('flags-js client SDK_READY_TIMED_OUT event received, resolving timeoutPromise but flags will return control treatment');
                            resolve();
                        });
                    });
                    anonClient_1.setAttributes(attributes_1);
                    clients.anonymous = anonClient_1;
                    userClient = factory.client((attributes_1 === null || attributes_1 === void 0 ? void 0 : attributes_1.cisId) || 'anon');
                    userClient.setAttributes(attributes_1);
                    clients.user = userClient;
                    _j.label = 7;
                case 7:
                    if (!manager) {
                        debug$1('Creating manager');
                        manager = factory.manager();
                    }
                    result = {
                        factory: factory,
                        manager: manager,
                        clients: {
                            anonymous: clients.anonymous,
                            user: clients.user,
                        },
                        getFeatureFlag: getFeatureFlag,
                        getFeatureFlags: getFeatureFlags,
                    };
                    debug$1('agnosticFeatureFlagFactory result constructed. Now waiting for ready ...', result);
                    return [4 /*yield*/, Promise.race([
                            timeoutPromise,
                            Promise.all([(_b = clients.anonymous) === null || _b === void 0 ? void 0 : _b.ready(), (_c = clients.user) === null || _c === void 0 ? void 0 : _c.ready(), manager === null || manager === void 0 ? void 0 : manager.ready()]),
                        ])];
                case 8:
                    _j.sent();
                    debug$1('agnosticFeatureFlagFactory done. Returning result:', result);
                    return [2 /*return*/, result];
            }
        });
    });
}
// as required by https://help.split.io/hc/en-us/articles/360058730852-Browser-SDK#shutdown
function shutdown() {
    return __awaiter(this, void 0, void 0, function () {
        var promises;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    log('Shutting down feature flag factory and destroying clients and manager');
                    if (!factory) return [3 /*break*/, 2];
                    return [4 /*yield*/, factory.destroy()];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    promises = [];
                    if (clients.user) {
                        promises.push(clients.user.destroy());
                    }
                    if (clients.anonymous) {
                        promises.push(clients.anonymous.destroy());
                    }
                    return [4 /*yield*/, Promise.all(promises)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    factory = undefined;
                    manager = undefined;
                    clients = {};
                    localFlagOverrides = {};
                    return [2 /*return*/];
            }
        });
    });
}
function resetFactory() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    log('resetFactory called, clearing factory, clients, and manager');
                    return [4 /*yield*/, shutdown()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}

var debug = debugVerbose('flags-js:react');
// Promise.withResolvers() is too new, so use this manual implementation until it is available
var resolve;
var reject;
var factoryPromise = new Promise(function (res, rej) {
    resolve = res;
    reject = rej;
});
var factoryCreated = false;
var localStandardAttributes;
function featureFlagFactory() {
    return __awaiter(this, arguments, void 0, function (standardAttributes, authKey, mockFlags, flagOverrides) {
        if (standardAttributes === void 0) { standardAttributes = getStandardAttributes(); }
        if (authKey === void 0) { authKey = splitioAuthKey; }
        if (mockFlags === void 0) { mockFlags = undefined; }
        if (flagOverrides === void 0) { flagOverrides = undefined; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    debug('called featureFlagFactory with:', {
                        standardAttributes: standardAttributes,
                        authKey: authKey,
                        mockFlags: mockFlags,
                        flagOverrides: flagOverrides,
                    });
                    debug('featureFlagFactory called with promise:', factoryCreated, factoryPromise);
                    if (!factoryCreated) return [3 /*break*/, 2];
                    debug('updating overrides');
                    updateFlagOverrides(flagOverrides || {});
                    debug('updated overrides, now updating mock flags ');
                    return [4 /*yield*/, updateMockFlags(mockFlags || {})];
                case 1:
                    _a.sent();
                    debug('featureFlagFactory returning existing promise');
                    return [2 /*return*/, factoryPromise];
                case 2:
                    factoryCreated = true;
                    try {
                        debug('Creating feature flag factory');
                        resolve(agnosticFeatureFlagFactory({
                            standardAttributes: standardAttributes,
                            authKey: authKey,
                            mockFlags: mockFlags,
                            flagOverrides: flagOverrides,
                        }));
                    }
                    catch (error) {
                        debug('Error creating feature flag factory:', error);
                        reject(error);
                    }
                    return [2 /*return*/, factoryPromise];
            }
        });
    });
}
function updateStandardAttributes(newAttributes) {
    return __awaiter(this, void 0, void 0, function () {
        var anonId, factory;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    anonId = handleAndGetAnonIdCookie();
                    return [4 /*yield*/, getStandardAttributesCommon(__assign(__assign(__assign({ appName: appName, flagAttributes: flagAttributes }, localStandardAttributes), newAttributes), { anonId: anonId }))];
                case 1:
                    localStandardAttributes = _e.sent();
                    return [4 /*yield*/, factoryPromise];
                case 2:
                    factory = _e.sent();
                    debug('Updating standard attributes in factory:', factory);
                    if (factory) {
                        debug('Updating standard attributes in factory:', localStandardAttributes);
                        (_b = (_a = factory.clients) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.setAttributes(localStandardAttributes);
                        (_d = (_c = factory.clients) === null || _c === void 0 ? void 0 : _c.anonymous) === null || _d === void 0 ? void 0 : _d.setAttributes(localStandardAttributes);
                    }
                    else {
                        debug('No factory available to update standard attributes');
                    }
                    return [2 /*return*/, localStandardAttributes];
            }
        });
    });
}
function getStandardAttributes() {
    return __awaiter(this, arguments, void 0, function (language) {
        var anonId;
        if (language === void 0) { language = 'en'; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    debug('getStandardAttributes called:', language, localStandardAttributes);
                    if (localStandardAttributes) {
                        debug('Returning cached standard attributes:', localStandardAttributes);
                        return [2 /*return*/, localStandardAttributes];
                    }
                    anonId = handleAndGetAnonIdCookie();
                    return [4 /*yield*/, getStandardAttributesCommon({
                            appName: appName,
                            anonId: anonId,
                            geoData: geoData,
                            locale: language,
                            baseUrl: baseUrl,
                            flagAttributes: flagAttributes,
                        })];
                case 1:
                    localStandardAttributes = _a.sent();
                    return [2 /*return*/, localStandardAttributes];
            }
        });
    });
}
/**
 * Get the singleton feature flag factory instance. This is the primary way for non-stack code to utilize this library.
 * This depends on the factory being created by official providers so has an implicit dependency on the stack code running.
 * If the stack code doesn't run, this will just hang waiting fo the promise to resolve.
 * @returns {Promise<FactoryResult>} The factory result containing the Split.io SDK and feature flag methods.
 */
function getFeatureFlagFactory() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, factoryPromise];
        });
    });
}
function resetFeatureFlagFactory() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    debug('resetFeatureFlagFactory called');
                    return [4 /*yield*/, resetFactory()];
                case 1:
                    _a.sent();
                    factoryPromise = new Promise(function (res, rej) {
                        resolve = res;
                        reject = rej;
                    });
                    factoryCreated = false;
                    localStandardAttributes = undefined;
                    return [2 /*return*/];
            }
        });
    });
}

export { controlFeatureFlag, featureFlagFactory, getFeatureFlagFactory, getStandardAttributes, resetFeatureFlagFactory, shutdown, updateFlagOverrides, updateMockFlags, updateStandardAttributes };
